import React from "react";

import {Typography} from "../../../designSystem/components/Typography";
import {Paragraph} from "../../../designSystem/components/Paragraph";
import {GoBackNavigationIconButton} from "../../../widgets/GoBackNavigationIconButton";

export const AgreementTerms = () => (
  <div className="p-8 flex flex-col gap-y-6">
    <div className="self-start">
      <GoBackNavigationIconButton />
    </div>

    {/* Title */}
    <div className="flex flex-col gap-y-4">
      <Typography variant="title" align="center">
        屏東遠距醫療諮詢
      </Typography>
      <Typography variant="title" align="center">
        遠距諮詢告知同意書
      </Typography>
    </div>

    {/* Content */}
    <div>
      <Paragraph text="親愛的用戶您好："/>
      <Paragraph
        text="感謝您使用【屏東遠距醫療諮詢】的服務，我們十分重視您的個資安全與使用權利，請詳閱以下諮詢注意事項，並且同意本次諮詢的相關規範："/>
      <Paragraph tab={1} text="1. 您瞭解並同意本平台主要服務對象為臺灣之民眾。"/>
      <Paragraph tab={1}
                 text="2. 您瞭解並同意當本平台發現民眾有不適當使用而需進一步釐清身分時，會要求民眾填寫基本資料、於必要時上傳證件已核對身分。"/>
      <Paragraph tab={1}
                 text="3. 您瞭解並同意有諮詢需求時，須完成【諮詢表單】之填寫；送出【諮詢表單】完成後始開始諮詢服務。"/>
      <Paragraph tab={1}
                 text="4. 您瞭解並同意若您在諮詢中途離開超過 10 分鐘 (定義為超過 10 分鐘未回應官方帳號所發出之訊息)，將視同您放棄本次諮詢的權利。"/>
      <Paragraph tab={1}
                 text="5. 您瞭解並同意申請諮詢服務前請確認您的設備是否可以使用，並且確認您的網路訊號良好，請保持在通訊品質良好的位置使用本服務。"/>
      <Paragraph tab={1}
                 text="5. 您瞭解並同意申請諮詢服務前請確認您的設備是否可以使用，並且確認您的網路訊號良好，請保持在通訊品質良好的位置使用本服務。"/>
      <Paragraph tab={1}
                 text="6. 您瞭解並同意諮詢的過程平台將紀錄您的諮詢內容，並且由平台於保存期效內妥善保管，必要的時候將提供給相關人員(包括但不限於平時就醫的診所)，諮詢過程皆不可截圖及外流談話內容，如違反規定平台將保留法律追訴權。"/>
      <Paragraph tab={1}
                 text="7. 您瞭解並同意本服務僅提供諮詢方式尋求醫療人員建議，並非針對個案進行診療行為，且無法取代診療機構執行的現場診斷方式，本平台的諮詢建議僅供您未來就診的參考。"/>
      <Paragraph tab={1} text="8. 您瞭解並同意若您或諮詢對象當下身體極為不適，請立即就醫治療。"/>
      <Paragraph tab={1}
                 text="9. 諮詢的服務範圍，僅就平台取得之資訊進行評估與建議，若因無法知悉取得的資訊而衍生的問題本平台與諮詢醫療人員不負相關責任，諮詢建議僅供參考意見不作為任何訴訟或法律之用途。"/>
      <Paragraph text="請同意以上規範再進行諮詢，謝謝您。"/>
    </div>
  </div>
)